import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Range, Data } from 'slate';
import EntityTypes from '../../../types/EntityTypes';
import { linkify } from '../index';
import allowDecoration from './allowDecoration';
import StyleTypes from '../../../types/StyleTypes';
import { LINE_BREAK_CHARACTER, WHITESPACE_CHARACTER } from '../../constants';
var FORBIDDEN_ENTITIES = [EntityTypes.LINK, EntityTypes.MENTION, EntityTypes.NOTELINK, EntityTypes.LINE_BREAK];
var FORBIDDEN_MARKS = [EntityTypes.LINK, StyleTypes.CODE];
export default function decorateNode(node, editor, next) {
  var others = next() || [];

  if (!allowDecoration(node)) {
    return others;
  }

  var text = node.text.replace(LINE_BREAK_CHARACTER, WHITESPACE_CHARACTER);
  var entities = linkify.match(text);
  var decorations = [];

  if (entities) {
    entities.forEach(function (entity) {
      var _node$getTextAtOffset = node.getTextAtOffset(entity.index),
          anchorKey = _node$getTextAtOffset.key;

      var _node$getTextAtOffset2 = node.getTextAtOffset(entity.lastIndex - 1),
          focusKey = _node$getTextAtOffset2.key;

      var rawRange = {
        anchor: {
          key: anchorKey,
          path: node.getPath(anchorKey),
          offset: entity.index - node.getOffset(anchorKey)
        },
        focus: {
          key: focusKey,
          path: node.getPath(focusKey),
          offset: entity.lastIndex - node.getOffset(focusKey)
        }
      };
      var range = Range.create(rawRange);
      var hasForbiddenMarksAtRange = node.getMarksAtRange(range).find(function (mark) {
        return FORBIDDEN_MARKS.includes(mark.type);
      });
      var hasForbiddenEntitiesAtRange = node.getLeafInlinesAtRange(range).find(function (inline) {
        return FORBIDDEN_ENTITIES.includes(inline.type);
      });

      if (!hasForbiddenMarksAtRange && !hasForbiddenEntitiesAtRange) {
        var decoration = _objectSpread({}, rawRange, {
          type: EntityTypes.LINK,
          data: Data.create({
            url: entity.url
          })
        });

        decorations.push(decoration);
      }
    });
  }

  return [].concat(_toConsumableArray(others), decorations);
}